module.exports = __webpack_public_path__ + "static/media/room_active.0d449a20.svg";